module.exports = __webpack_public_path__ + "media/assets/images/logos/kitchen_c3_logo_symbol-f3e25456f4276e45f37f18d4d199d908.svg";